export default {
  home: 'خانه',
  inbox: 'رخدادها',
  alltasks: 'تمام وظیفه‌ها',
  manage: 'مدیریت',
  directs: 'مکالمه‌ها',
  projects: 'پروژه‌ها',
  unreadMessage: 'پیام جدید',
  outpatinet: 'محتوای معاونت درمان',
  pdpPanel: 'پنل آموزش کارکنان',
  tags: 'برچسب‌ها',
  others: 'سایر',
  settings: 'تنظیمات',

  providerContent(providerName: string) {
    return `${providerName}`;
  },
};
